// extracted by mini-css-extract-plugin
module.exports = {"apiContainer":"api_apiContainer__xD2Mr","copyBtn":"api_copyBtn__2vul3"};